import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngxs/store';

/* istanbul ignore */
@Injectable({
  providedIn: 'root'
})
export class AccessPredictiveConfigService{


  constructor(
    private store: Store,
    private router: Router
  ) {}

  public canActivate() {
    let predictiveMode = this.store.selectSnapshot(state => state.configurations.predictiveFailure.mode);
    if(predictiveMode === null){
      this.router.navigateByUrl('/home');
      return false;
    }

    return true;
  }
}
